/* PASSWORD RESET WITH TOKEN */

let email = urlParams.get('email');
let checkout_url = urlParams.get('checkout_url');


$(document).on('click', '#changePassword', async function (e) {

  if ($('#CustomerPassword').val().length < 8) {
 $('#changePassword-error span').text("New password should be at least 8 characters long")
      $('#changePassword-error').show();
    return false;
  }
  if ($('#CustomerPassword').val() !== $('#RepeatCustomerPassword').val()) {
 $('#changePassword-error span').text("The passwords do not match")
      $('#changePassword-error').show();
    return false;
  }

  
});


/* LOGIN */

$('#customer_login button').click(function (e) {
  e.preventDefault();


  _learnq.push(['identify', {
    // Change the line below to dynamically print the user's email.
    '$email' : $('input[name="customer[email]"]').val()
  }]);
  
  var settings = {
    "url": "https://api.v3.editsuits.com/store/checkUser",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    "data": {
      "email": $('input[name="customer[email]"]').val()
    }
  };

  $('#customer_logins button').addClass('button--loading');
  $.ajax(settings).done(async function (response) {
    $('#wrong_password').hide();
    if (response.status == 'error') {
      $('#wrong_password').show();
      $('#customer_login button').removeClass('button--loading');
    }

   
    if (response.status == "success") {

      if (response.details === 'existing-active') {

      
        $('#customer_login').attr('action', '/account/login');
        $('#customer_login').trigger('submit');
        setTimeout(() => {
             $(this).trigger('submit');
        }, 2000)
       
        
      }

      if (response.details === 'new') {

         $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#no_account').css('display', 'inline');
         $('#account_activation').hide();

      }

      if (response.details === 'existing-inactive') {

         $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#no_account').hide();
         $('#account_activation').css('display', 'inline');
      
      }
      
      
    }
  });
})

/* REGISTER */

$('#create_customer button').click(function (e) {
  e.preventDefault()

  $('input').removeClass('withError');
    if ($('[name="customer[first_name]"]').val().length === 0 && !$('[name="customer[first_name]"]').hasClass('withError')) {
        $('[name="customer[first_name]"]').addClass('withError')
    }
    if ($('[name="customer[last_name]"]').val().length === 0 && !$('[name="customer[last_name]"]').hasClass('withError')) {
        $('[name="customer[last_name]"]').addClass('withError')
    }
    if ($('[name="customer[password]"]').val().length === 0 && !$('[name="customer[password]"]').hasClass('withError')) {
        $('[name="customer[password]"]').addClass('withError')
    }
    if ($('[name="customer[email]"]').val().indexOf('@') < 0 || $('[name="customer[email]"]').val().indexOf('.') < 0 && !$('[name="customer[email]"]').hasClass('withError')) {
        $('[name="customer[email]"]').addClass('withError')
    }


  _learnq.push(['identify', {
    // Change the line below to dynamically print the user's email.
    '$email' : $('[name="customer[email]"]').val()
  }]);

    if ($('input.withError').length > 0) return false;

 

  var settings = {
    "url": "https://api.v3.editsuits.com/store/checkUser",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    "data": {
      "email": $('input[name="customer[email]"]').val()
    }
  };

  $('#create_customer button').addClass('button--loading');
  $.ajax(settings).done(async function (response) {
  
    $('#registerError').hide();
    if (response.status == 'error') {
      $('#create_customer button').removeClass('button--loading');
      $('#registerError span').text(response.details);
      $('#registerError').show();
    }
    if (response.status == "success") {

      $('#create_customer button').removeClass('button--loading');

      if (response.details === 'existing-active') {

        $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#existing_account').css('display', 'inline');
         $('#account_activation').hide();
       
        
      }

      if (response.details === 'new') {
 
        $('#create_customer').attr('action', '/account');
        $('#create_customer').trigger('submit');
        setTimeout(() => {
             $(this).trigger('submit');
        }, 2000)

      }

      if (response.details === 'existing-inactive') {

         $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#existing_account').hide();
         $('#account_activation').css('display', 'inline');
      
      }
      
      
    }
  });
})

$(function () {
  
// $('#customer_login').attr('action', '');
 $('#create_customer').attr('action', '');
 $('#customer_login').attr('action', '');
// $('#RecoverEmail').closest('form').attr('action', '');

});